/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AllPollsQueryVariables = {||};
export type AllPollsQueryResponse = {|
  +allPolls: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +pollName: string,
        +question: string,
        +isCompleted: ?boolean,
        +pollChoices: {|
          +edges: $ReadOnlyArray<?{|
            +node: ?{|
              +choice: string,
              +choicePercentage: ?number,
              +id: string,
            |}
          |}>
        |},
        +reward: number,
      |}
    |}>
  |}
|};
export type AllPollsQuery = {|
  variables: AllPollsQueryVariables,
  response: AllPollsQueryResponse,
|};
*/


/*
query AllPollsQuery {
  allPolls {
    edges {
      node {
        id
        pollName
        question
        isCompleted
        pollChoices {
          edges {
            node {
              choice
              choicePercentage
              id
            }
          }
        }
        reward
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PollNodeConnection",
    "kind": "LinkedField",
    "name": "allPolls",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PollNodeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PollNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pollName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "question",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isCompleted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PollChoicesNodeConnection",
                "kind": "LinkedField",
                "name": "pollChoices",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PollChoicesNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PollChoicesNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "choice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "choicePercentage",
                            "storageKey": null
                          },
                          (v0/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reward",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllPollsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AllPollsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8aebff1eccf424aa929609f8265bc36c",
    "id": null,
    "metadata": {},
    "name": "AllPollsQuery",
    "operationKind": "query",
    "text": "query AllPollsQuery {\n  allPolls {\n    edges {\n      node {\n        id\n        pollName\n        question\n        isCompleted\n        pollChoices {\n          edges {\n            node {\n              choice\n              choicePercentage\n              id\n            }\n          }\n        }\n        reward\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a4b05644391545fe9f0953996f6d601e';

module.exports = node;
